import { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { apiRequests } from '../../../shared/api/apiRequests';

const BAN_TYPES = {
  ADMIN_PANEL: 1,
  FULL: 999,
};

export const BanUserModal = ({ show, handleClose, userId, onBan }) => {
  const [banType, setBanType] = useState(BAN_TYPES.ADMIN_PANEL);
  const [reason, setReason] = useState('');
  const [banUntil, setBanUntil] = useState('');

  const handleBan = () => {
    const body = {
      Type: banType,
      Reason: reason,
      BanBefore: banUntil ? new Date(banUntil).toISOString() : '0001-01-01T00:00:00',
      Id: userId,
    };

    apiRequests.users
      .ban(body)
      .then(() => {
        toast.success('Пользователь успешно заблокирован');
        onBan(userId);
        handleClose();
      })
      .catch(() => {
        toast.error('Ошибка при блокировке пользователя');
      });
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Заблокировать пользователя</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Тип блокировки</Form.Label>
            <Form.Select value={banType} onChange={(e) => setBanType(Number(e.target.value))}>
              <option value={BAN_TYPES.ADMIN_PANEL}>Блокировка в админ-панели</option>
              <option value={BAN_TYPES.FULL}>Полная блокировка</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Причина</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Заблокировать до</Form.Label>
            <Form.Control
              type="date"
              value={banUntil}
              onChange={(e) => setBanUntil(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Отмена
        </Button>
        <Button variant="danger" onClick={handleBan}>
          Заблокировать
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
